(function () {
  'use strict';

  var IMAGE_SELECTOR = [
    '.productgrid--items .productitem--image img[data-rimg]',
    '.productgrid--item .productitem--image img[data-rimg]',
    '.search-results-products .productitem--image img[data-rimg]'
  ].join(',');
  var MAX_RETRIES = 2;
  var RETRY_DELAY = 700;
  var STUCK_CHECK_DELAY = 3000;
  var VIEWPORT_MARGIN = 700;

  function firstSrcsetUrl(srcset) {
    if (!srcset) return '';
    var firstCandidate = srcset.split(',')[0];
    return firstCandidate ? firstCandidate.trim().split(/\s+/)[0] : '';
  }

  function getImageUrl(img) {
    return img.currentSrc ||
      firstSrcsetUrl(img.getAttribute('srcset')) ||
      img.getAttribute('src') ||
      '';
  }

  function getCurrentImageUrl(img) {
    return getImageUrl(img);
  }

  function deriveTemplateUrl(img) {
    var template = img.getAttribute('data-rimg-template');
    if (!template || template.indexOf('{size}') === -1) return '';

    return template.replace('{size}', '512x');
  }

  function isDataUrl(url) {
    return url.indexOf('data:') === 0;
  }

  function isPlaceholderImage(img) {
    return img.naturalWidth > 0 &&
      isDataUrl(getCurrentImageUrl(img)) &&
      !!deriveTemplateUrl(img);
  }

  function normalizeUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return url;
  }

  function isNearViewport(img) {
    var rect = img.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    return rect.bottom >= -VIEWPORT_MARGIN && rect.top <= viewportHeight + VIEWPORT_MARGIN;
  }

  function shouldRetry(img) {
    var state = img.getAttribute('data-rimg');
    var currentUrl = getCurrentImageUrl(img);
    var url = currentUrl;
    var hasTemplateUrl = !!deriveTemplateUrl(img);

    if (!url || isDataUrl(url)) {
      url = deriveTemplateUrl(img);
    }

    if (!url || isDataUrl(url) || !isNearViewport(img)) return false;

    if (img.naturalWidth > 0) {
      return isDataUrl(currentUrl) && hasTemplateUrl;
    }

    return img.naturalWidth === 0 && (state === 'loading' || state === 'error' || img.complete);
  }

  function dispatchImageEvent(img, eventName) {
    var event;

    if (typeof window.Event === 'function') {
      event = new Event(eventName, { bubbles: true });
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
    }

    img.dispatchEvent(event);
  }

  function applyLoadedUrl(img, url) {
    img.setAttribute('srcset', url);
    img.setAttribute('src', url);
    img.setAttribute('data-rimg', 'loaded');
    dispatchImageEvent(img, 'rimg:load');
  }

  function retryImage(img) {
    var retries = parseInt(img.getAttribute('data-auxito-image-retries') || '0', 10);
    var url = getImageUrl(img);
    var probe;

    if (!url || isDataUrl(url)) {
      url = deriveTemplateUrl(img);
    }

    url = normalizeUrl(url);

    if (!url || isDataUrl(url) || retries >= MAX_RETRIES) return;
    if (img.getAttribute('data-auxito-image-retry-active') === 'true') return;

    img.setAttribute('data-auxito-image-retry-active', 'true');
    img.setAttribute('data-auxito-image-retries', String(retries + 1));

    probe = new Image();
    probe.onload = function () {
      img.removeAttribute('data-auxito-image-retry-active');

      if (probe.naturalWidth > 0) {
        applyLoadedUrl(img, url);
      }
    };
    probe.onerror = function () {
      img.removeAttribute('data-auxito-image-retry-active');

      if (retries + 1 < MAX_RETRIES) {
        window.setTimeout(function () {
          retryImage(img);
        }, RETRY_DELAY);
      }
    };
    probe.src = url;
  }

  function bindImage(img) {
    if (img.getAttribute('data-auxito-image-retry-bound') === 'true') return;

    img.setAttribute('data-auxito-image-retry-bound', 'true');
    img.addEventListener('load', function () {
      if (isPlaceholderImage(img)) {
        if (isNearViewport(img)) {
          retryImage(img);
        }
        return;
      }

      if (img.naturalWidth > 0 && !isDataUrl(getCurrentImageUrl(img))) {
        img.setAttribute('data-rimg', 'loaded');
      }
    });
    img.addEventListener('error', function () {
      window.setTimeout(function () {
        retryImage(img);
      }, RETRY_DELAY);
    });
  }

  function scanImages() {
    Array.prototype.forEach.call(document.querySelectorAll(IMAGE_SELECTOR), function (img) {
      bindImage(img);

      if (shouldRetry(img)) {
        if (isPlaceholderImage(img)) {
          retryImage(img);
          return;
        }

        window.setTimeout(function () {
          if (shouldRetry(img)) {
            retryImage(img);
          }
        }, RETRY_DELAY);
      }
    });
  }

  function debounce(fn, wait) {
    var timer = null;

    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  }

  function observeProductGrid() {
    var root = document.querySelector('.productgrid--items') ||
      document.querySelector('.search-results-products');

    if (!root || !window.MutationObserver) return;

    new MutationObserver(debounce(scanImages, 150)).observe(root, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    var rescan = debounce(scanImages, 150);

    scanImages();
    observeProductGrid();
    window.setTimeout(scanImages, STUCK_CHECK_DELAY);
    window.setTimeout(scanImages, STUCK_CHECK_DELAY * 2);
    window.addEventListener('scroll', rescan, { passive: true });
    window.addEventListener('resize', rescan);
    document.addEventListener('shopify:section:load', scanImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
